import {
  Area,
  AreaChart,
  ReferenceDot,
  ReferenceLine,
  ResponsiveContainer,
  YAxis,
} from "recharts";

/** Tiny season trend line. Color follows the latest value's sign. */
export function Sparkline({
  data,
  height = 36,
  width,
}: {
  data: number[];
  height?: number;
  width?: number;
}) {
  if (!data || data.length < 2) {
    return (
      <div
        className="flex items-center justify-center text-[10px] text-faint"
        style={{ height, width: width ?? "100%" }}
      >
        no history yet
      </div>
    );
  }
  const last = data[data.length - 1];
  const color = last >= 0 ? "#16c784" : "#ea3943";
  const id = `spark-${Math.round(last * 1e6)}-${data.length}`;
  const series = data.map((v, i) => ({ i, v }));
  const min = Math.min(...data, 0);
  const max = Math.max(...data, 0);

  return (
    <div style={{ height, width: width ?? "100%" }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={series} margin={{ top: 3, right: 5, bottom: 3, left: 0 }}>
          <defs>
            <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.4} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <YAxis hide domain={[min, max]} />
          <ReferenceLine y={0} stroke="#3a4757" strokeDasharray="2 3" />
          <Area
            type="monotone"
            dataKey="v"
            stroke={color}
            strokeWidth={2}
            fill={`url(#${id})`}
            isAnimationActive={false}
            dot={false}
          />
          <ReferenceDot
            x={series.length - 1}
            y={last}
            r={2.5}
            fill={color}
            stroke="none"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
